
import {post} from '@/utils/request';
import {erpserver} from '@/utils/baseUrl';
// import{sse_url} from '@/utils/baseUrl';

// //库区列表
// export async function getList(params) {
//     return post(erpserver+'/storekq/getList', params, true)
// }

